import { Validator } from 'vee-validate';

import dateCompareRule from './rules/age_limit';
import percentLimitRule from './rules/percent_limit';
import checkEmailRule from './rules/check_email';
import checkTitleRule from './rules/check_title';
import expiryDateRule from './rules/expiry_date';
import checkCardRule from './rules/check_card';

Validator.extend('ageLimit', {
  validate: (value, limit) => {
    const ageLimit = limit[0];
    let format = 'DD/MM/YYYY';
    if (limit[1]) {
      format = limit[1];
    }

    return dateCompareRule({ value }, ageLimit, format);
  },
  params: ['limit'],
});

Validator.extend('percentLimit', {
  validate: (value, limit) => {
    const percentLimit = limit[0];
    return percentLimitRule({ value }, percentLimit);
  },
  params: ['limit'],
});

Validator.extend('checkEmail', {
  validate: (value, data) => {
    const isEmailExist = data[0];
    return checkEmailRule({ value }, isEmailExist);
  },
  params: ['data'],
});

Validator.extend('check_title', {
  validate: (value) => {
    return checkTitleRule({ value });
  },
  params: ['value'],
});

Validator.extend('check_expiry_date', {
  validate: (value) => {
    return expiryDateRule({ value });
  },
  params: ['value'],
});

Validator.extend('check_card', {
  validate: (value) => {
    return checkCardRule({ value });
  },
  params: ['value'],
});
